/*
 * Urban Customz — the category rail as an in-page quick filter (All Designs only; sections/uc-collection-header.liquid).
 *
 * A chip names one or two values of the existing Occasion / Interest filters. A click replaces every
 * Occasion / Interest value in the current URL with the chip's (single-select across the rail), keeps
 * the drawer's other filters and the sort, and hands the query to Dawn's facet renderer: the grid
 * section is fetched by section_id and swapped in place, the product count updates, and the URL is
 * pushed with the History API, so refresh, Back, Forward and sharing all work. "All" clears the rail's
 * values only. Nothing is stored anywhere; no other link on the page changes.
 *
 * Without this script (or on the category collection pages) the chips are plain links to their
 * collection pages, which stay the canonical, shareable, linkable destinations.
 */
(function () {
  "use strict";
  var rail = document.querySelector("[data-uc-rail]");
  if (!rail) return;
  var PARAMS = (rail.getAttribute("data-rail-params") || "").split(",").filter(Boolean);
  var PREFIX = "filter.p.m.uc_catalog.";

  function facets() {
    var C = customElements.get("facet-filters-form");
    return C && typeof C.renderPage === "function" ? C : null;
  }

  /** "occasion=Bachelor Party|Bachelorette Party" → [["filter.p.m.uc_catalog.occasion", "Bachelor Party"], ...] */
  function parseFilter(spec) {
    if (!spec) return [];
    var i = spec.indexOf("=");
    if (i < 0) return [];
    var param = PREFIX + spec.slice(0, i).trim();
    if (PARAMS.indexOf(param) === -1) return [];
    return spec.slice(i + 1).split("|").map(function (v) { return [param, v.trim()]; }).filter(function (p) { return p[1]; });
  }

  /** The rail's current values from the URL, as "param=value" strings. */
  function railValues(search) {
    var out = [];
    new URLSearchParams(search).forEach(function (v, k) { if (PARAMS.indexOf(k) > -1) out.push(k + "=" + v); });
    return out.sort();
  }

  function markActive(search) {
    var current = railValues(search).join("\n");
    var chips = rail.querySelectorAll(".uc-ch__cat[data-filter]");
    var found = false;
    for (var i = 0; i < chips.length; i++) {
      var pairs = parseFilter(chips[i].getAttribute("data-filter"));
      var mine = pairs.map(function (p) { return p[0] + "=" + p[1]; }).sort().join("\n");
      var on = pairs.length ? mine === current : current === "";
      chips[i].classList.toggle("is-current", on);
      if (on) chips[i].setAttribute("aria-current", "true"); else chips[i].removeAttribute("aria-current");
      if (on && pairs.length) found = true;
      // A hidden category that becomes current leaves the More menu so it reads as the selection.
      if (chips[i].classList.contains("uc-ch__cat--menu") && on) promote(chips[i]);
    }
    var more = rail.querySelector("[data-uc-rail-more]");
    if (more) more.classList.toggle("has-current", false);
    void found;
  }

  function promote(chip) {
    var more = rail.querySelector("[data-uc-rail-more]");
    if (!more) return;
    var demoted = rail.querySelector(".uc-ch__cat--promoted");
    if (demoted && demoted !== chip) {
      demoted.classList.remove("uc-ch__cat--promoted");
      demoted.classList.add("uc-ch__cat--menu");
      more.querySelector(".uc-ch__menu").appendChild(demoted);
    }
    chip.classList.remove("uc-ch__cat--menu");
    chip.classList.add("uc-ch__cat--promoted");
    rail.querySelector(".uc-ch__cats").insertBefore(chip, more);
    more.open = false;
  }

  function apply(pairs) {
    var F = facets();
    if (!F) return false; // facets.js not here: the link navigates to the collection page
    var params = new URLSearchParams(window.location.search);
    PARAMS.forEach(function (p) { params.delete(p); });
    pairs.forEach(function (p) { params.append(p[0], p[1]); });
    params.delete("page");
    var search = params.toString();
    // Dawn's renderPage pushes the URL itself (History API) and re-renders grid, count and drawer.
    F.renderPage(search, null, true);
    markActive("?" + search);
    return true;
  }

  rail.addEventListener("click", function (e) {
    var chip = e.target.closest && e.target.closest(".uc-ch__cat[data-filter]");
    if (!chip || chip.tagName !== "A") return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return; // open in a new tab: the collection page
    var spec = chip.getAttribute("data-filter");
    var pairs = parseFilter(spec);
    if (spec && !pairs.length) return; // a chip without a mapped filter stays a plain link
    if (apply(pairs)) e.preventDefault();
  });

  // The menu closes on outside click / Escape; a selection inside it closes it too (apply() handles that via promote).
  var more = rail.querySelector("[data-uc-rail-more]");
  if (more) {
    document.addEventListener("click", function (e) { if (more.open && !more.contains(e.target)) more.open = false; });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && more.open) { more.open = false; more.querySelector("summary").focus(); } });
  }

  // Back / Forward (Dawn re-renders the grid on popstate) and the drawer's own Occasion / Interest picks.
  window.addEventListener("popstate", function () { setTimeout(function () { markActive(window.location.search); }, 0); });
  var grid = document.getElementById("ProductGridContainer");
  if (grid && "MutationObserver" in window) new MutationObserver(function () { markActive(window.location.search); }).observe(grid, { childList: true });
  markActive(window.location.search);
})();
